// @flow
/* eslint jsx-a11y/no-static-element-interactions:0 */

import React from 'react';
import BackgroundPinImages from 'app/common/react/components/growth/activation/BackgroundPinImages';
import DefaultCSS from 'app/common/react/components/growth/unauth/DefaultCSS';
import i18n from 'app/common/lib/i18n';
import InlineStyle from 'app/common/react/components/InlineStyle';
import InspiredWallSignup from 'app/common/react/components/growth/unauth/signup/InspiredWallSignup/InspiredWallSignup';
import PageController from 'app/common/react/components/growth/unauth/PageController';
import ResetCSS from 'app/common/react/components/growth/unauth/ResetCSS';
import SignupCSS from 'app/common/react/components/growth/unauth/signup/SignupCSS';
import UnauthHomePageCSS from 'app/common/react/components/growth/unauth/UnauthHomePage/UnauthHomePageCSS';
import { Box } from 'gestalt';
import { type ResourceError } from 'app/common/lib/react/withResource';

type Props = {|
  error?: ResourceError,
|};

const cssStyles = () => DefaultCSS() + UnauthHomePageCSS() + ResetCSS() + SignupCSS();

const getErrorMessage = (error) => {
  // $FlowFixMe: node resource returns the error object from request-promise
  const statusCode = error && (error.http_status || error.statusCode);
  if (statusCode === 404) {
    return i18n._("Sorry, we can't find that page.", 'Error message to indicate page not found');
  } else {
    return null;
  }
};

export const UnauthErrorPage = (props: Props) => (
  <PageController page="home">
    <Box
      height="100%"
      width="100%"
      position="absolute"
      top
      overflow="scrollY"
      data-test-id="errorPage"
    >
      <BackgroundPinImages disableFlexibleBGPins />
      <Box
        bottom
        left
        right
        top
        position="absolute"
        overflow="auto"
        display="flex"
        direction="column"
        dangerouslySetInlineStyle={{ __style: { background: 'rgba(0,0,0,.5)' } }}
      />
      <InlineStyle unsafeCSS={cssStyles()} />
      <Box
        display="flex"
        direction="column"
        position="absolute"
        bottom
        left
        right
        top
        overflow="auto"
      >
        <div style={{ flex: 1 }}>
          <InspiredWallSignup
            container="home_page"
            shouldRenderErrorToast
            errorMessage={getErrorMessage(props.error)}
          />
        </div>
      </Box>
    </Box>
  </PageController>
);

export default UnauthErrorPage;
